import { RouterModule } from '@angular/router';
import { ParamMap } from '@angular/router';
import { Router } from '@angular/router';
import { Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ArchitecturePage } from '../../../../../../../website/pages/ArchitecturePage/ArchitecturePage';
import { CapabilitiesPage } from '../../../../../../../website/pages/CapabilitiesPage/CapabilitiesPage';
import { GettingStartedPage } from '../../../../../../../website/pages/GettingStartedPage/GettingStartedPage';
import { HomePage } from '../../../../../../../website/pages/HomePage/HomePage';
import { PluginsPage } from '../../../../../../../website/pages/PluginsPage/PluginsPage';
import { RealTimePage } from '../../../../../../../website/pages/RealTimePage/RealTimePage';
import { AboutAsidePage } from '../../../../../../../website/pages/about/AboutAsidePage/AboutAsidePage';
import { AboutPage } from '../../../../../../../website/pages/about/AboutPage/AboutPage';
import { BuildPipelinePage } from '../../../../../../../website/pages/architecture/BuildPipelinePage/BuildPipelinePage';
import { DataFlowPage } from '../../../../../../../website/pages/architecture/DataFlowPage/DataFlowPage';
import { ModuleGraphPage } from '../../../../../../../website/pages/architecture/ModuleGraphPage/ModuleGraphPage';
import { RuntimePage } from '../../../../../../../website/pages/architecture/RuntimePage/RuntimePage';
import { StackDiagramPage } from '../../../../../../../website/pages/architecture/StackDiagramPage/StackDiagramPage';
import { ArchitectureAsidePage } from '../../../../../../../website/pages/aside/ArchitectureAsidePage/ArchitectureAsidePage';
import { CapabilitiesAsidePage } from '../../../../../../../website/pages/aside/CapabilitiesAsidePage/CapabilitiesAsidePage';
import { FrameworksAsidePage } from '../../../../../../../website/pages/aside/FrameworksAsidePage/FrameworksAsidePage';
import { PluginsAsidePage } from '../../../../../../../website/pages/aside/PluginsAsidePage/PluginsAsidePage';
import { RealTimeAsidePage } from '../../../../../../../website/pages/aside/RealTimeAsidePage/RealTimeAsidePage';
import { AngularGenerationPage } from '../../../../../../../website/pages/capabilities/AngularGenerationPage/AngularGenerationPage';
import { EventSystemPage } from '../../../../../../../website/pages/capabilities/EventSystemPage/EventSystemPage';
import { PluginModelPage } from '../../../../../../../website/pages/capabilities/PluginModelPage/PluginModelPage';
import { RealTimeMessagingPage } from '../../../../../../../website/pages/capabilities/RealTimeMessagingPage/RealTimeMessagingPage';
import { RenderingPage } from '../../../../../../../website/pages/capabilities/RenderingPage/RenderingPage';
import { SpiExtensibilityPage } from '../../../../../../../website/pages/capabilities/SpiExtensibilityPage/SpiExtensibilityPage';
import { AngularMaterialFrameworkPage } from '../../../../../../../website/pages/frameworks/AngularMaterialFrameworkPage/AngularMaterialFrameworkPage';
import { BootstrapFrameworkPage } from '../../../../../../../website/pages/frameworks/BootstrapFrameworkPage/BootstrapFrameworkPage';
import { FrameworksPage } from '../../../../../../../website/pages/frameworks/FrameworksPage/FrameworksPage';
import { JQueryUIFrameworkPage } from '../../../../../../../website/pages/frameworks/JQueryUIFrameworkPage/JQueryUIFrameworkPage';
import { WebAwesomeFrameworkPage } from '../../../../../../../website/pages/frameworks/WebAwesomeFrameworkPage/WebAwesomeFrameworkPage';
import { WebAwesomeProFrameworkPage } from '../../../../../../../website/pages/frameworks/WebAwesomeProFrameworkPage/WebAwesomeProFrameworkPage';
import { BSAccordionPage } from '../../../../../../../website/pages/frameworks/components/BSAccordionPage/BSAccordionPage';
import { BSAlertPage } from '../../../../../../../website/pages/frameworks/components/BSAlertPage/BSAlertPage';
import { BSBadgePage } from '../../../../../../../website/pages/frameworks/components/BSBadgePage/BSBadgePage';
import { BSBreadcrumbContainerPage } from '../../../../../../../website/pages/frameworks/components/BSBreadcrumbContainerPage/BSBreadcrumbContainerPage';
import { BSButtonGroupPage } from '../../../../../../../website/pages/frameworks/components/BSButtonGroupPage/BSButtonGroupPage';
import { BSButtonPage } from '../../../../../../../website/pages/frameworks/components/BSButtonPage/BSButtonPage';
import { BSCardPage } from '../../../../../../../website/pages/frameworks/components/BSCardPage/BSCardPage';
import { BSCarouselPage } from '../../../../../../../website/pages/frameworks/components/BSCarouselPage/BSCarouselPage';
import { BSCheckBoxPage } from '../../../../../../../website/pages/frameworks/components/BSCheckBoxPage/BSCheckBoxPage';
import { BSCloseIconPage } from '../../../../../../../website/pages/frameworks/components/BSCloseIconPage/BSCloseIconPage';
import { BSCollapsePage } from '../../../../../../../website/pages/frameworks/components/BSCollapsePage/BSCollapsePage';
import { BSContainerPage } from '../../../../../../../website/pages/frameworks/components/BSContainerPage/BSContainerPage';
import { BSDatePickerPage } from '../../../../../../../website/pages/frameworks/components/BSDatePickerPage/BSDatePickerPage';
import { BSDropDownPage } from '../../../../../../../website/pages/frameworks/components/BSDropDownPage/BSDropDownPage';
import { BSFigurePage } from '../../../../../../../website/pages/frameworks/components/BSFigurePage/BSFigurePage';
import { BSFileUploadPage } from '../../../../../../../website/pages/frameworks/components/BSFileUploadPage/BSFileUploadPage';
import { BSFormPage } from '../../../../../../../website/pages/frameworks/components/BSFormPage/BSFormPage';
import { BSImagePage } from '../../../../../../../website/pages/frameworks/components/BSImagePage/BSImagePage';
import { BSJumbotronPage } from '../../../../../../../website/pages/frameworks/components/BSJumbotronPage/BSJumbotronPage';
import { BSListGroupPage } from '../../../../../../../website/pages/frameworks/components/BSListGroupPage/BSListGroupPage';
import { BSMediaPage } from '../../../../../../../website/pages/frameworks/components/BSMediaPage/BSMediaPage';
import { BSModalPage } from '../../../../../../../website/pages/frameworks/components/BSModalPage/BSModalPage';
import { BSNavBarPage } from '../../../../../../../website/pages/frameworks/components/BSNavBarPage/BSNavBarPage';
import { BSNavsPage } from '../../../../../../../website/pages/frameworks/components/BSNavsPage/BSNavsPage';
import { BSPaginationPage } from '../../../../../../../website/pages/frameworks/components/BSPaginationPage/BSPaginationPage';
import { BSPopOverPage } from '../../../../../../../website/pages/frameworks/components/BSPopOverPage/BSPopOverPage';
import { BSProgressBarPage } from '../../../../../../../website/pages/frameworks/components/BSProgressBarPage/BSProgressBarPage';
import { BSRadioButtonPage } from '../../../../../../../website/pages/frameworks/components/BSRadioButtonPage/BSRadioButtonPage';
import { BSRangePage } from '../../../../../../../website/pages/frameworks/components/BSRangePage/BSRangePage';
import { BSSelectPage } from '../../../../../../../website/pages/frameworks/components/BSSelectPage/BSSelectPage';
import { BSSwitchPage } from '../../../../../../../website/pages/frameworks/components/BSSwitchPage/BSSwitchPage';
import { BSTablePage } from '../../../../../../../website/pages/frameworks/components/BSTablePage/BSTablePage';
import { BSTimePickerPage } from '../../../../../../../website/pages/frameworks/components/BSTimePickerPage/BSTimePickerPage';
import { BSToastPage } from '../../../../../../../website/pages/frameworks/components/BSToastPage/BSToastPage';
import { BSTogglePage } from '../../../../../../../website/pages/frameworks/components/BSTogglePage/BSTogglePage';
import { JQUIAccordionPage } from '../../../../../../../website/pages/frameworks/components/JQUIAccordionPage/JQUIAccordionPage';
import { JQUIAutoCompletePage } from '../../../../../../../website/pages/frameworks/components/JQUIAutoCompletePage/JQUIAutoCompletePage';
import { JQUIButtonPage } from '../../../../../../../website/pages/frameworks/components/JQUIButtonPage/JQUIButtonPage';
import { JQUICheckBoxGroupPage } from '../../../../../../../website/pages/frameworks/components/JQUICheckBoxGroupPage/JQUICheckBoxGroupPage';
import { JQUIDatePickerPage } from '../../../../../../../website/pages/frameworks/components/JQUIDatePickerPage/JQUIDatePickerPage';
import { JQUIDialogPage } from '../../../../../../../website/pages/frameworks/components/JQUIDialogPage/JQUIDialogPage';
import { JQUIDraggablePage } from '../../../../../../../website/pages/frameworks/components/JQUIDraggablePage/JQUIDraggablePage';
import { JQUIDroppablePage } from '../../../../../../../website/pages/frameworks/components/JQUIDroppablePage/JQUIDroppablePage';
import { JQUIMenuPage } from '../../../../../../../website/pages/frameworks/components/JQUIMenuPage/JQUIMenuPage';
import { JQUIProgressBarPage } from '../../../../../../../website/pages/frameworks/components/JQUIProgressBarPage/JQUIProgressBarPage';
import { JQUIResizablePage } from '../../../../../../../website/pages/frameworks/components/JQUIResizablePage/JQUIResizablePage';
import { JQUISelectMenuPage } from '../../../../../../../website/pages/frameworks/components/JQUISelectMenuPage/JQUISelectMenuPage';
import { JQUISelectablePage } from '../../../../../../../website/pages/frameworks/components/JQUISelectablePage/JQUISelectablePage';
import { JQUISliderPage } from '../../../../../../../website/pages/frameworks/components/JQUISliderPage/JQUISliderPage';
import { JQUISortablePage } from '../../../../../../../website/pages/frameworks/components/JQUISortablePage/JQUISortablePage';
import { JQUISpinnerPage } from '../../../../../../../website/pages/frameworks/components/JQUISpinnerPage/JQUISpinnerPage';
import { JQUITabsPage } from '../../../../../../../website/pages/frameworks/components/JQUITabsPage/JQUITabsPage';
import { JQUITooltipPage } from '../../../../../../../website/pages/frameworks/components/JQUITooltipPage/JQUITooltipPage';
import { MatAccordionPage } from '../../../../../../../website/pages/frameworks/components/MatAccordionPage/MatAccordionPage';
import { MatAutoCompletePage } from '../../../../../../../website/pages/frameworks/components/MatAutoCompletePage/MatAutoCompletePage';
import { MatButtonPage } from '../../../../../../../website/pages/frameworks/components/MatButtonPage/MatButtonPage';
import { MatCheckboxPage } from '../../../../../../../website/pages/frameworks/components/MatCheckboxPage/MatCheckboxPage';
import { MatChipAutoCompletePage } from '../../../../../../../website/pages/frameworks/components/MatChipAutoCompletePage/MatChipAutoCompletePage';
import { MatDialogPage } from '../../../../../../../website/pages/frameworks/components/MatDialogPage/MatDialogPage';
import { MatFormFieldPage } from '../../../../../../../website/pages/frameworks/components/MatFormFieldPage/MatFormFieldPage';
import { MatIconPage } from '../../../../../../../website/pages/frameworks/components/MatIconPage/MatIconPage';
import { MatProgressBarPage } from '../../../../../../../website/pages/frameworks/components/MatProgressBarPage/MatProgressBarPage';
import { MatSelectPage } from '../../../../../../../website/pages/frameworks/components/MatSelectPage/MatSelectPage';
import { MatTablePage } from '../../../../../../../website/pages/frameworks/components/MatTablePage/MatTablePage';
import { MatTablePaginatorPage } from '../../../../../../../website/pages/frameworks/components/MatTablePaginatorPage/MatTablePaginatorPage';
import { WaAnimatedImagePage } from '../../../../../../../website/pages/frameworks/components/WaAnimatedImagePage/WaAnimatedImagePage';
import { WaAnimationPage } from '../../../../../../../website/pages/frameworks/components/WaAnimationPage/WaAnimationPage';
import { WaAvatarGroupPage } from '../../../../../../../website/pages/frameworks/components/WaAvatarGroupPage/WaAvatarGroupPage';
import { WaAvatarPage } from '../../../../../../../website/pages/frameworks/components/WaAvatarPage/WaAvatarPage';
import { WaBadgePage } from '../../../../../../../website/pages/frameworks/components/WaBadgePage/WaBadgePage';
import { WaBarChartProPage } from '../../../../../../../website/pages/frameworks/components/WaBarChartProPage/WaBarChartProPage';
import { WaBreadcrumbItemPage } from '../../../../../../../website/pages/frameworks/components/WaBreadcrumbItemPage/WaBreadcrumbItemPage';
import { WaBreadcrumbsPage } from '../../../../../../../website/pages/frameworks/components/WaBreadcrumbsPage/WaBreadcrumbsPage';
import { WaBubbleChartProPage } from '../../../../../../../website/pages/frameworks/components/WaBubbleChartProPage/WaBubbleChartProPage';
import { WaButtonGroupPage } from '../../../../../../../website/pages/frameworks/components/WaButtonGroupPage/WaButtonGroupPage';
import { WaButtonPage } from '../../../../../../../website/pages/frameworks/components/WaButtonPage/WaButtonPage';
import { WaCalloutPage } from '../../../../../../../website/pages/frameworks/components/WaCalloutPage/WaCalloutPage';
import { WaCardPage } from '../../../../../../../website/pages/frameworks/components/WaCardPage/WaCardPage';
import { WaCarouselItemPage } from '../../../../../../../website/pages/frameworks/components/WaCarouselItemPage/WaCarouselItemPage';
import { WaCarouselPage } from '../../../../../../../website/pages/frameworks/components/WaCarouselPage/WaCarouselPage';
import { WaChartProPage } from '../../../../../../../website/pages/frameworks/components/WaChartProPage/WaChartProPage';
import { WaCheckboxPage } from '../../../../../../../website/pages/frameworks/components/WaCheckboxPage/WaCheckboxPage';
import { WaClusterPage } from '../../../../../../../website/pages/frameworks/components/WaClusterPage/WaClusterPage';
import { WaColorPickerPage } from '../../../../../../../website/pages/frameworks/components/WaColorPickerPage/WaColorPickerPage';
import { WaComboboxProPage } from '../../../../../../../website/pages/frameworks/components/WaComboboxProPage/WaComboboxProPage';
import { WaComparisonPage } from '../../../../../../../website/pages/frameworks/components/WaComparisonPage/WaComparisonPage';
import { WaCopyButtonPage } from '../../../../../../../website/pages/frameworks/components/WaCopyButtonPage/WaCopyButtonPage';
import { WaDetailsPage } from '../../../../../../../website/pages/frameworks/components/WaDetailsPage/WaDetailsPage';
import { WaDialogPage } from '../../../../../../../website/pages/frameworks/components/WaDialogPage/WaDialogPage';
import { WaDivPage } from '../../../../../../../website/pages/frameworks/components/WaDivPage/WaDivPage';
import { WaDividerPage } from '../../../../../../../website/pages/frameworks/components/WaDividerPage/WaDividerPage';
import { WaDoughnutChartProPage } from '../../../../../../../website/pages/frameworks/components/WaDoughnutChartProPage/WaDoughnutChartProPage';
import { WaDrawerPage } from '../../../../../../../website/pages/frameworks/components/WaDrawerPage/WaDrawerPage';
import { WaDropDownPage } from '../../../../../../../website/pages/frameworks/components/WaDropDownPage/WaDropDownPage';
import { WaDropdownItemPage } from '../../../../../../../website/pages/frameworks/components/WaDropdownItemPage/WaDropdownItemPage';
import { WaFileInputProPage } from '../../../../../../../website/pages/frameworks/components/WaFileInputProPage/WaFileInputProPage';
import { WaFlankPage } from '../../../../../../../website/pages/frameworks/components/WaFlankPage/WaFlankPage';
import { WaFormatBytesPage } from '../../../../../../../website/pages/frameworks/components/WaFormatBytesPage/WaFormatBytesPage';
import { WaFormatDatePage } from '../../../../../../../website/pages/frameworks/components/WaFormatDatePage/WaFormatDatePage';
import { WaFormatNumberPage } from '../../../../../../../website/pages/frameworks/components/WaFormatNumberPage/WaFormatNumberPage';
import { WaFramePage } from '../../../../../../../website/pages/frameworks/components/WaFramePage/WaFramePage';
import { WaGridPage } from '../../../../../../../website/pages/frameworks/components/WaGridPage/WaGridPage';
import { WaIconFAProPage } from '../../../../../../../website/pages/frameworks/components/WaIconFAProPage/WaIconFAProPage';
import { WaIconPage } from '../../../../../../../website/pages/frameworks/components/WaIconPage/WaIconPage';
import { WaImageComparePage } from '../../../../../../../website/pages/frameworks/components/WaImageComparePage/WaImageComparePage';
import { WaIncludePage } from '../../../../../../../website/pages/frameworks/components/WaIncludePage/WaIncludePage';
import { WaInputPage } from '../../../../../../../website/pages/frameworks/components/WaInputPage/WaInputPage';
import { WaIntersectionObserverPage } from '../../../../../../../website/pages/frameworks/components/WaIntersectionObserverPage/WaIntersectionObserverPage';
import { WaLineChartProPage } from '../../../../../../../website/pages/frameworks/components/WaLineChartProPage/WaLineChartProPage';
import { WaMarkdownPage } from '../../../../../../../website/pages/frameworks/components/WaMarkdownPage/WaMarkdownPage';
import { WaMutationObserverPage } from '../../../../../../../website/pages/frameworks/components/WaMutationObserverPage/WaMutationObserverPage';
import { WaNumberInputPage } from '../../../../../../../website/pages/frameworks/components/WaNumberInputPage/WaNumberInputPage';
import { WaPageBannerProPage } from '../../../../../../../website/pages/frameworks/components/WaPageBannerProPage/WaPageBannerProPage';
import { WaPageContentProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentProPage/WaPageContentProPage';
import { WaPageContentsAsideProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsAsideProPage/WaPageContentsAsideProPage';
import { WaPageContentsMainFooterProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsMainFooterProPage/WaPageContentsMainFooterProPage';
import { WaPageContentsMainHeaderProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsMainHeaderProPage/WaPageContentsMainHeaderProPage';
import { WaPageContentsMainProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsMainProPage/WaPageContentsMainProPage';
import { WaPageContentsNavigationFooterProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsNavigationFooterProPage/WaPageContentsNavigationFooterProPage';
import { WaPageContentsNavigationHeaderProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsNavigationHeaderProPage/WaPageContentsNavigationHeaderProPage';
import { WaPageContentsNavigationProPage } from '../../../../../../../website/pages/frameworks/components/WaPageContentsNavigationProPage/WaPageContentsNavigationProPage';
import { WaPageDialogWrapperProPage } from '../../../../../../../website/pages/frameworks/components/WaPageDialogWrapperProPage/WaPageDialogWrapperProPage';
import { WaPageFooterProPage } from '../../../../../../../website/pages/frameworks/components/WaPageFooterProPage/WaPageFooterProPage';
import { WaPageHeaderProPage } from '../../../../../../../website/pages/frameworks/components/WaPageHeaderProPage/WaPageHeaderProPage';
import { WaPageMenuProPage } from '../../../../../../../website/pages/frameworks/components/WaPageMenuProPage/WaPageMenuProPage';
import { WaPageNavigationToggleIconProPage } from '../../../../../../../website/pages/frameworks/components/WaPageNavigationToggleIconProPage/WaPageNavigationToggleIconProPage';
import { WaPageNavigationToggleProPage } from '../../../../../../../website/pages/frameworks/components/WaPageNavigationToggleProPage/WaPageNavigationToggleProPage';
import { WaPageProPage } from '../../../../../../../website/pages/frameworks/components/WaPageProPage/WaPageProPage';
import { WaPageSkipToContentProPage } from '../../../../../../../website/pages/frameworks/components/WaPageSkipToContentProPage/WaPageSkipToContentProPage';
import { WaPageSubHeaderProPage } from '../../../../../../../website/pages/frameworks/components/WaPageSubHeaderProPage/WaPageSubHeaderProPage';
import { WaPieChartProPage } from '../../../../../../../website/pages/frameworks/components/WaPieChartProPage/WaPieChartProPage';
import { WaPolarAreaChartProPage } from '../../../../../../../website/pages/frameworks/components/WaPolarAreaChartProPage/WaPolarAreaChartProPage';
import { WaPopoverPage } from '../../../../../../../website/pages/frameworks/components/WaPopoverPage/WaPopoverPage';
import { WaPopupPage } from '../../../../../../../website/pages/frameworks/components/WaPopupPage/WaPopupPage';
import { WaProgressBarPage } from '../../../../../../../website/pages/frameworks/components/WaProgressBarPage/WaProgressBarPage';
import { WaProgressRingPage } from '../../../../../../../website/pages/frameworks/components/WaProgressRingPage/WaProgressRingPage';
import { WaQRCodePage } from '../../../../../../../website/pages/frameworks/components/WaQRCodePage/WaQRCodePage';
import { WaRadarChartProPage } from '../../../../../../../website/pages/frameworks/components/WaRadarChartProPage/WaRadarChartProPage';
import { WaRadioGroupPage } from '../../../../../../../website/pages/frameworks/components/WaRadioGroupPage/WaRadioGroupPage';
import { WaRadioPage } from '../../../../../../../website/pages/frameworks/components/WaRadioPage/WaRadioPage';
import { WaRangePage } from '../../../../../../../website/pages/frameworks/components/WaRangePage/WaRangePage';
import { WaRatingPage } from '../../../../../../../website/pages/frameworks/components/WaRatingPage/WaRatingPage';
import { WaRelativeTimePage } from '../../../../../../../website/pages/frameworks/components/WaRelativeTimePage/WaRelativeTimePage';
import { WaResizeObserverPage } from '../../../../../../../website/pages/frameworks/components/WaResizeObserverPage/WaResizeObserverPage';
import { WaScatterChartProPage } from '../../../../../../../website/pages/frameworks/components/WaScatterChartProPage/WaScatterChartProPage';
import { WaScrollerPage } from '../../../../../../../website/pages/frameworks/components/WaScrollerPage/WaScrollerPage';
import { WaSelectOptionPage } from '../../../../../../../website/pages/frameworks/components/WaSelectOptionPage/WaSelectOptionPage';
import { WaSelectPage } from '../../../../../../../website/pages/frameworks/components/WaSelectPage/WaSelectPage';
import { WaSkeletonPage } from '../../../../../../../website/pages/frameworks/components/WaSkeletonPage/WaSkeletonPage';
import { WaSparklineProPage } from '../../../../../../../website/pages/frameworks/components/WaSparklineProPage/WaSparklineProPage';
import { WaSpinnerPage } from '../../../../../../../website/pages/frameworks/components/WaSpinnerPage/WaSpinnerPage';
import { WaSplitButtonPage } from '../../../../../../../website/pages/frameworks/components/WaSplitButtonPage/WaSplitButtonPage';
import { WaSplitPage } from '../../../../../../../website/pages/frameworks/components/WaSplitPage/WaSplitPage';
import { WaSplitPanelPage } from '../../../../../../../website/pages/frameworks/components/WaSplitPanelPage/WaSplitPanelPage';
import { WaStackPage } from '../../../../../../../website/pages/frameworks/components/WaStackPage/WaStackPage';
import { WaSwitchPage } from '../../../../../../../website/pages/frameworks/components/WaSwitchPage/WaSwitchPage';
import { WaTabGroupPage } from '../../../../../../../website/pages/frameworks/components/WaTabGroupPage/WaTabGroupPage';
import { WaTabPage } from '../../../../../../../website/pages/frameworks/components/WaTabPage/WaTabPage';
import { WaTabPanelPage } from '../../../../../../../website/pages/frameworks/components/WaTabPanelPage/WaTabPanelPage';
import { WaTagPage } from '../../../../../../../website/pages/frameworks/components/WaTagPage/WaTagPage';
import { WaTextAreaPage } from '../../../../../../../website/pages/frameworks/components/WaTextAreaPage/WaTextAreaPage';
import { WaTextPage } from '../../../../../../../website/pages/frameworks/components/WaTextPage/WaTextPage';
import { WaToastContainerPage } from '../../../../../../../website/pages/frameworks/components/WaToastContainerPage/WaToastContainerPage';
import { WaToastDataServicePage } from '../../../../../../../website/pages/frameworks/components/WaToastDataServicePage/WaToastDataServicePage';
import { WaToastItemPage } from '../../../../../../../website/pages/frameworks/components/WaToastItemPage/WaToastItemPage';
import { WaTooltipPage } from '../../../../../../../website/pages/frameworks/components/WaTooltipPage/WaTooltipPage';
import { WaTreeItemPage } from '../../../../../../../website/pages/frameworks/components/WaTreeItemPage/WaTreeItemPage';
import { WaTreePage } from '../../../../../../../website/pages/frameworks/components/WaTreePage/WaTreePage';
import { WaZoomableFramePage } from '../../../../../../../website/pages/frameworks/components/WaZoomableFramePage/WaZoomableFramePage';
import { ApplicationPage } from '../../../../../../../website/pages/gettingstarted/ApplicationPage/ApplicationPage';
import { BuildAndRunPage } from '../../../../../../../website/pages/gettingstarted/BuildAndRunPage/BuildAndRunPage';
import { GettingStartedAsidePage } from '../../../../../../../website/pages/gettingstarted/GettingStartedAsidePage/GettingStartedAsidePage';
import { NextStepsPage } from '../../../../../../../website/pages/gettingstarted/NextStepsPage/NextStepsPage';
import { WhatsHappeningPage } from '../../../../../../../website/pages/gettingstarted/WhatsHappeningPage/WhatsHappeningPage';
import { HomeAsidePage } from '../../../../../../../website/pages/home/HomeAsidePage/HomeAsidePage';
import { SalesDashboard } from '../../../../../../../website/pages/home/SalesDashboard/SalesDashboard';
import { AgChartsEnterprisePluginPage } from '../../../../../../../website/pages/plugins/AgChartsEnterprisePluginPage/AgChartsEnterprisePluginPage';
import { AgChartsPluginPage } from '../../../../../../../website/pages/plugins/AgChartsPluginPage/AgChartsPluginPage';
import { AgGridEnterprisePluginPage } from '../../../../../../../website/pages/plugins/AgGridEnterprisePluginPage/AgGridEnterprisePluginPage';
import { AgGridPluginPage } from '../../../../../../../website/pages/plugins/AgGridPluginPage/AgGridPluginPage';
import { AngularMavenPluginPage } from '../../../../../../../website/pages/plugins/AngularMavenPluginPage/AngularMavenPluginPage';
import { AngularPluginPage } from '../../../../../../../website/pages/plugins/AngularPluginPage/AngularPluginPage';
import { BootstrapPluginPage } from '../../../../../../../website/pages/plugins/BootstrapPluginPage/BootstrapPluginPage';
import { C3PluginPage } from '../../../../../../../website/pages/plugins/C3PluginPage/C3PluginPage';
import { ChartJsPluginPage } from '../../../../../../../website/pages/plugins/ChartJsPluginPage/ChartJsPluginPage';
import { ClientPluginPage } from '../../../../../../../website/pages/plugins/ClientPluginPage/ClientPluginPage';
import { CorePluginPage } from '../../../../../../../website/pages/plugins/CorePluginPage/CorePluginPage';
import { D3PluginPage } from '../../../../../../../website/pages/plugins/D3PluginPage/D3PluginPage';
import { DataTablesPluginPage } from '../../../../../../../website/pages/plugins/DataTablesPluginPage/DataTablesPluginPage';
import { EasingPluginPage } from '../../../../../../../website/pages/plugins/EasingPluginPage/EasingPluginPage';
import { EasyPieChartPluginPage } from '../../../../../../../website/pages/plugins/EasyPieChartPluginPage/EasyPieChartPluginPage';
import { FontAwesomePluginPage } from '../../../../../../../website/pages/plugins/FontAwesomePluginPage/FontAwesomePluginPage';
import { FontAwesomeProPluginPage } from '../../../../../../../website/pages/plugins/FontAwesomeProPluginPage/FontAwesomeProPluginPage';
import { FullCalendarPluginPage } from '../../../../../../../website/pages/plugins/FullCalendarPluginPage/FullCalendarPluginPage';
import { FullCalendarProPluginPage } from '../../../../../../../website/pages/plugins/FullCalendarProPluginPage/FullCalendarProPluginPage';
import { GlobalizePluginPage } from '../../../../../../../website/pages/plugins/GlobalizePluginPage/GlobalizePluginPage';
import { GlyphiconsPluginPage } from '../../../../../../../website/pages/plugins/GlyphiconsPluginPage/GlyphiconsPluginPage';
import { JQPlotPluginPage } from '../../../../../../../website/pages/plugins/JQPlotPluginPage/JQPlotPluginPage';
import { JQueryPluginPage } from '../../../../../../../website/pages/plugins/JQueryPluginPage/JQueryPluginPage';
import { JQueryUIPluginPage } from '../../../../../../../website/pages/plugins/JQueryUIPluginPage/JQueryUIPluginPage';
import { LocalStoragePluginPage } from '../../../../../../../website/pages/plugins/LocalStoragePluginPage/LocalStoragePluginPage';
import { MaterialDesignIconsPluginPage } from '../../../../../../../website/pages/plugins/MaterialDesignIconsPluginPage/MaterialDesignIconsPluginPage';
import { MaterialIconsPluginPage } from '../../../../../../../website/pages/plugins/MaterialIconsPluginPage/MaterialIconsPluginPage';
import { PlusAsTabPluginPage } from '../../../../../../../website/pages/plugins/PlusAsTabPluginPage/PlusAsTabPluginPage';
import { PrettifyPluginPage } from '../../../../../../../website/pages/plugins/PrettifyPluginPage/PrettifyPluginPage';
import { RabbitMQPluginPage } from '../../../../../../../website/pages/plugins/RabbitMQPluginPage/RabbitMQPluginPage';
import { SessionStoragePluginPage } from '../../../../../../../website/pages/plugins/SessionStoragePluginPage/SessionStoragePluginPage';
import { SkyconsPluginPage } from '../../../../../../../website/pages/plugins/SkyconsPluginPage/SkyconsPluginPage';
import { ThemifyIconsPluginPage } from '../../../../../../../website/pages/plugins/ThemifyIconsPluginPage/ThemifyIconsPluginPage';
import { ToastrPluginPage } from '../../../../../../../website/pages/plugins/ToastrPluginPage/ToastrPluginPage';
import { TypeScriptClientPluginPage } from '../../../../../../../website/pages/plugins/TypeScriptClientPluginPage/TypeScriptClientPluginPage';
import { VertxPluginPage } from '../../../../../../../website/pages/plugins/VertxPluginPage/VertxPluginPage';
import { WavesEffectPluginPage } from '../../../../../../../website/pages/plugins/WavesEffectPluginPage/WavesEffectPluginPage';
import { WayPointsPluginPage } from '../../../../../../../website/pages/plugins/WayPointsPluginPage/WayPointsPluginPage';
import { WeatherIconsPluginPage } from '../../../../../../../website/pages/plugins/WeatherIconsPluginPage/WeatherIconsPluginPage';
import { WebAwesomePluginPage } from '../../../../../../../website/pages/plugins/WebAwesomePluginPage/WebAwesomePluginPage';
import { WebAwesomeProPluginPage } from '../../../../../../../website/pages/plugins/WebAwesomeProPluginPage/WebAwesomeProPluginPage';
import { AgAreaChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgAreaChartPluginCompPage/AgAreaChartPluginCompPage';
import { AgBarChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgBarChartPluginCompPage/AgBarChartPluginCompPage';
import { AgBubbleChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgBubbleChartPluginCompPage/AgBubbleChartPluginCompPage';
import { AgCandlestickSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgCandlestickSeriesPluginCompPage/AgCandlestickSeriesPluginCompPage';
import { AgChartOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgChartOptionsPluginCompPage/AgChartOptionsPluginCompPage';
import { AgChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgChartPluginCompPage/AgChartPluginCompPage';
import { AgChordSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgChordSeriesPluginCompPage/AgChordSeriesPluginCompPage';
import { AgCombinationChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgCombinationChartPluginCompPage/AgCombinationChartPluginCompPage';
import { AgDonutChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgDonutChartPluginCompPage/AgDonutChartPluginCompPage';
import { AgFunnelSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgFunnelSeriesPluginCompPage/AgFunnelSeriesPluginCompPage';
import { AgGridColumnDefPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgGridColumnDefPluginCompPage/AgGridColumnDefPluginCompPage';
import { AgGridEnterpriseColumnDefPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgGridEnterpriseColumnDefPluginCompPage/AgGridEnterpriseColumnDefPluginCompPage';
import { AgGridEnterpriseOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgGridEnterpriseOptionsPluginCompPage/AgGridEnterpriseOptionsPluginCompPage';
import { AgGridOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgGridOptionsPluginCompPage/AgGridOptionsPluginCompPage';
import { AgGridPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgGridPluginCompPage/AgGridPluginCompPage';
import { AgHeatmapSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgHeatmapSeriesPluginCompPage/AgHeatmapSeriesPluginCompPage';
import { AgHistogramSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgHistogramSeriesPluginCompPage/AgHistogramSeriesPluginCompPage';
import { AgLineChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgLineChartPluginCompPage/AgLineChartPluginCompPage';
import { AgNightingaleSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgNightingaleSeriesPluginCompPage/AgNightingaleSeriesPluginCompPage';
import { AgOhlcSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgOhlcSeriesPluginCompPage/AgOhlcSeriesPluginCompPage';
import { AgPieChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgPieChartPluginCompPage/AgPieChartPluginCompPage';
import { AgRadarAreaSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgRadarAreaSeriesPluginCompPage/AgRadarAreaSeriesPluginCompPage';
import { AgRadarLineSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgRadarLineSeriesPluginCompPage/AgRadarLineSeriesPluginCompPage';
import { AgRadialBarSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgRadialBarSeriesPluginCompPage/AgRadialBarSeriesPluginCompPage';
import { AgRadialColumnSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgRadialColumnSeriesPluginCompPage/AgRadialColumnSeriesPluginCompPage';
import { AgRangeAreaSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgRangeAreaSeriesPluginCompPage/AgRangeAreaSeriesPluginCompPage';
import { AgRangeBarSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgRangeBarSeriesPluginCompPage/AgRangeBarSeriesPluginCompPage';
import { AgSankeySeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgSankeySeriesPluginCompPage/AgSankeySeriesPluginCompPage';
import { AgScatterChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgScatterChartPluginCompPage/AgScatterChartPluginCompPage';
import { AgSunburstSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgSunburstSeriesPluginCompPage/AgSunburstSeriesPluginCompPage';
import { AgTreemapSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgTreemapSeriesPluginCompPage/AgTreemapSeriesPluginCompPage';
import { AgWaterfallSeriesPluginCompPage } from '../../../../../../../website/pages/plugins/components/AgWaterfallSeriesPluginCompPage/AgWaterfallSeriesPluginCompPage';
import { AjaxCallIntercepterPluginCompPage } from '../../../../../../../website/pages/plugins/components/AjaxCallIntercepterPluginCompPage/AjaxCallIntercepterPluginCompPage';
import { AjaxCallPluginCompPage } from '../../../../../../../website/pages/plugins/components/AjaxCallPluginCompPage/AjaxCallPluginCompPage';
import { AjaxResponsePluginCompPage } from '../../../../../../../website/pages/plugins/components/AjaxResponsePluginCompPage/AjaxResponsePluginCompPage';
import { BSAccordionPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSAccordionPluginCompPage/BSAccordionPluginCompPage';
import { BSAlertPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSAlertPluginCompPage/BSAlertPluginCompPage';
import { BSBadgePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSBadgePluginCompPage/BSBadgePluginCompPage';
import { BSBreadcrumbContainerPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSBreadcrumbContainerPluginCompPage/BSBreadcrumbContainerPluginCompPage';
import { BSButtonGroupPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSButtonGroupPluginCompPage/BSButtonGroupPluginCompPage';
import { BSButtonPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSButtonPluginCompPage/BSButtonPluginCompPage';
import { BSCardPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSCardPluginCompPage/BSCardPluginCompPage';
import { BSCarouselPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSCarouselPluginCompPage/BSCarouselPluginCompPage';
import { BSCheckBoxPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSCheckBoxPluginCompPage/BSCheckBoxPluginCompPage';
import { BSCloseIconPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSCloseIconPluginCompPage/BSCloseIconPluginCompPage';
import { BSCollapsePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSCollapsePluginCompPage/BSCollapsePluginCompPage';
import { BSContainerPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSContainerPluginCompPage/BSContainerPluginCompPage';
import { BSDatePickerPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSDatePickerPluginCompPage/BSDatePickerPluginCompPage';
import { BSDropDownPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSDropDownPluginCompPage/BSDropDownPluginCompPage';
import { BSFigurePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSFigurePluginCompPage/BSFigurePluginCompPage';
import { BSFileUploadPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSFileUploadPluginCompPage/BSFileUploadPluginCompPage';
import { BSFormPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSFormPluginCompPage/BSFormPluginCompPage';
import { BSImagePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSImagePluginCompPage/BSImagePluginCompPage';
import { BSJumbotronPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSJumbotronPluginCompPage/BSJumbotronPluginCompPage';
import { BSListGroupPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSListGroupPluginCompPage/BSListGroupPluginCompPage';
import { BSMediaPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSMediaPluginCompPage/BSMediaPluginCompPage';
import { BSModalPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSModalPluginCompPage/BSModalPluginCompPage';
import { BSNavBarPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSNavBarPluginCompPage/BSNavBarPluginCompPage';
import { BSNavsPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSNavsPluginCompPage/BSNavsPluginCompPage';
import { BSPaginationPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSPaginationPluginCompPage/BSPaginationPluginCompPage';
import { BSPopOverPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSPopOverPluginCompPage/BSPopOverPluginCompPage';
import { BSProgressBarPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSProgressBarPluginCompPage/BSProgressBarPluginCompPage';
import { BSRadioButtonPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSRadioButtonPluginCompPage/BSRadioButtonPluginCompPage';
import { BSRangePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSRangePluginCompPage/BSRangePluginCompPage';
import { BSSelectPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSSelectPluginCompPage/BSSelectPluginCompPage';
import { BSSwitchPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSSwitchPluginCompPage/BSSwitchPluginCompPage';
import { BSTablePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSTablePluginCompPage/BSTablePluginCompPage';
import { BSTimePickerPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSTimePickerPluginCompPage/BSTimePickerPluginCompPage';
import { BSToastPluginCompPage } from '../../../../../../../website/pages/plugins/components/BSToastPluginCompPage/BSToastPluginCompPage';
import { BSTogglePluginCompPage } from '../../../../../../../website/pages/plugins/components/BSTogglePluginCompPage/BSTogglePluginCompPage';
import { BarChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/BarChartPluginCompPage/BarChartPluginCompPage';
import { DataCallIntercepterPluginCompPage } from '../../../../../../../website/pages/plugins/components/DataCallIntercepterPluginCompPage/DataCallIntercepterPluginCompPage';
import { DataTableColumnOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/DataTableColumnOptionsPluginCompPage/DataTableColumnOptionsPluginCompPage';
import { DataTableOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/DataTableOptionsPluginCompPage/DataTableOptionsPluginCompPage';
import { DataTablePageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/DataTablePageConfiguratorPluginCompPage/DataTablePageConfiguratorPluginCompPage';
import { DataTablePluginCompPage } from '../../../../../../../website/pages/plugins/components/DataTablePluginCompPage/DataTablePluginCompPage';
import { DataTablesButtonsOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/DataTablesButtonsOptionsPluginCompPage/DataTablesButtonsOptionsPluginCompPage';
import { DataTablesResponsiveOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/DataTablesResponsiveOptionsPluginCompPage/DataTablesResponsiveOptionsPluginCompPage';
import { DivSimplePluginCompPage } from '../../../../../../../website/pages/plugins/components/DivSimplePluginCompPage/DivSimplePluginCompPage';
import { DoughnutChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/DoughnutChartPluginCompPage/DoughnutChartPluginCompPage';
import { FeaturePluginCompPage } from '../../../../../../../website/pages/plugins/components/FeaturePluginCompPage/FeaturePluginCompPage';
import { FontAwesome5FamiliesPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesome5FamiliesPluginCompPage/FontAwesome5FamiliesPluginCompPage';
import { FontAwesome5ProIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesome5ProIconsPluginCompPage/FontAwesome5ProIconsPluginCompPage';
import { FontAwesome5ProPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesome5ProPageConfiguratorPluginCompPage/FontAwesome5ProPageConfiguratorPluginCompPage';
import { FontAwesome5ProStylesPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesome5ProStylesPluginCompPage/FontAwesome5ProStylesPluginCompPage';
import { FontAwesomeBrandIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeBrandIconsPluginCompPage/FontAwesomeBrandIconsPluginCompPage';
import { FontAwesomeDuotonePluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeDuotonePluginCompPage/FontAwesomeDuotonePluginCompPage';
import { FontAwesomeIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeIconsPluginCompPage/FontAwesomeIconsPluginCompPage';
import { FontAwesomeLayerCounterPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeLayerCounterPluginCompPage/FontAwesomeLayerCounterPluginCompPage';
import { FontAwesomeLayerTextPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeLayerTextPluginCompPage/FontAwesomeLayerTextPluginCompPage';
import { FontAwesomeLayersPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeLayersPluginCompPage/FontAwesomeLayersPluginCompPage';
import { FontAwesomeListPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeListPluginCompPage/FontAwesomeListPluginCompPage';
import { FontAwesomePluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomePluginCompPage/FontAwesomePluginCompPage';
import { FontAwesomeSizesPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeSizesPluginCompPage/FontAwesomeSizesPluginCompPage';
import { FontAwesomeStylesPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeStylesPluginCompPage/FontAwesomeStylesPluginCompPage';
import { FontAwesomeTransformsPluginCompPage } from '../../../../../../../website/pages/plugins/components/FontAwesomeTransformsPluginCompPage/FontAwesomeTransformsPluginCompPage';
import { FormPluginCompPage } from '../../../../../../../website/pages/plugins/components/FormPluginCompPage/FormPluginCompPage';
import { FullCalendarEventPluginCompPage } from '../../../../../../../website/pages/plugins/components/FullCalendarEventPluginCompPage/FullCalendarEventPluginCompPage';
import { FullCalendarOptionsPluginCompPage } from '../../../../../../../website/pages/plugins/components/FullCalendarOptionsPluginCompPage/FullCalendarOptionsPluginCompPage';
import { FullCalendarPluginCompPage } from '../../../../../../../website/pages/plugins/components/FullCalendarPluginCompPage/FullCalendarPluginCompPage';
import { FullCalendarProPluginCompPage } from '../../../../../../../website/pages/plugins/components/FullCalendarProPluginCompPage/FullCalendarProPluginCompPage';
import { GlyphiconPluginCompPage } from '../../../../../../../website/pages/plugins/components/GlyphiconPluginCompPage/GlyphiconPluginCompPage';
import { GlyphiconsPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/GlyphiconsPageConfiguratorPluginCompPage/GlyphiconsPageConfiguratorPluginCompPage';
import { GlyphiconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/GlyphiconsPluginCompPage/GlyphiconsPluginCompPage';
import { IPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/IPageConfiguratorPluginCompPage/IPageConfiguratorPluginCompPage';
import { IPagePluginCompPage } from '../../../../../../../website/pages/plugins/components/IPagePluginCompPage/IPagePluginCompPage';
import { IconFamilyPluginCompPage } from '../../../../../../../website/pages/plugins/components/IconFamilyPluginCompPage/IconFamilyPluginCompPage';
import { InputTextTypePluginCompPage } from '../../../../../../../website/pages/plugins/components/InputTextTypePluginCompPage/InputTextTypePluginCompPage';
import { JQEasingEffectsPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQEasingEffectsPluginCompPage/JQEasingEffectsPluginCompPage';
import { JQEasingPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQEasingPageConfiguratorPluginCompPage/JQEasingPageConfiguratorPluginCompPage';
import { JQUIAccordionPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIAccordionPluginCompPage/JQUIAccordionPluginCompPage';
import { JQUIAutoCompletePluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIAutoCompletePluginCompPage/JQUIAutoCompletePluginCompPage';
import { JQUIButtonPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIButtonPluginCompPage/JQUIButtonPluginCompPage';
import { JQUIDatePickerPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIDatePickerPluginCompPage/JQUIDatePickerPluginCompPage';
import { JQUIDialogPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIDialogPluginCompPage/JQUIDialogPluginCompPage';
import { JQUIDraggablePluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIDraggablePluginCompPage/JQUIDraggablePluginCompPage';
import { JQUIDroppablePluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIDroppablePluginCompPage/JQUIDroppablePluginCompPage';
import { JQUISliderPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUISliderPluginCompPage/JQUISliderPluginCompPage';
import { JQUISortablePluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUISortablePluginCompPage/JQUISortablePluginCompPage';
import { JQUITabsPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUITabsPluginCompPage/JQUITabsPluginCompPage';
import { JQUIToolTipPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQUIToolTipPluginCompPage/JQUIToolTipPluginCompPage';
import { JQueryInclusionModulePluginCompPage } from '../../../../../../../website/pages/plugins/components/JQueryInclusionModulePluginCompPage/JQueryInclusionModulePluginCompPage';
import { JQueryPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/JQueryPageConfiguratorPluginCompPage/JQueryPageConfiguratorPluginCompPage';
import { JWebMPAjaxServletPluginCompPage } from '../../../../../../../website/pages/plugins/components/JWebMPAjaxServletPluginCompPage/JWebMPAjaxServletPluginCompPage';
import { JWebMPCSSServletPluginCompPage } from '../../../../../../../website/pages/plugins/components/JWebMPCSSServletPluginCompPage/JWebMPCSSServletPluginCompPage';
import { JWebMPDataServletPluginCompPage } from '../../../../../../../website/pages/plugins/components/JWebMPDataServletPluginCompPage/JWebMPDataServletPluginCompPage';
import { JWebMPScriptServletPluginCompPage } from '../../../../../../../website/pages/plugins/components/JWebMPScriptServletPluginCompPage/JWebMPScriptServletPluginCompPage';
import { JWebMPVertxServletPluginCompPage } from '../../../../../../../website/pages/plugins/components/JWebMPVertxServletPluginCompPage/JWebMPVertxServletPluginCompPage';
import { LineChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/LineChartPluginCompPage/LineChartPluginCompPage';
import { MDIIconPluginCompPage } from '../../../../../../../website/pages/plugins/components/MDIIconPluginCompPage/MDIIconPluginCompPage';
import { MDIIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/MDIIconsPluginCompPage/MDIIconsPluginCompPage';
import { MaterialDesignIconColoursPluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialDesignIconColoursPluginCompPage/MaterialDesignIconColoursPluginCompPage';
import { MaterialDesignIconPluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialDesignIconPluginCompPage/MaterialDesignIconPluginCompPage';
import { MaterialDesignIconSizePluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialDesignIconSizePluginCompPage/MaterialDesignIconSizePluginCompPage';
import { MaterialDesignIconThemesPluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialDesignIconThemesPluginCompPage/MaterialDesignIconThemesPluginCompPage';
import { MaterialDesignIconsPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialDesignIconsPageConfiguratorPluginCompPage/MaterialDesignIconsPageConfiguratorPluginCompPage';
import { MaterialDesignIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialDesignIconsPluginCompPage/MaterialDesignIconsPluginCompPage';
import { MaterialIconsPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/MaterialIconsPageConfiguratorPluginCompPage/MaterialIconsPageConfiguratorPluginCompPage';
import { NGApplicationPluginCompPage } from '../../../../../../../website/pages/plugins/components/NGApplicationPluginCompPage/NGApplicationPluginCompPage';
import { NgForPluginCompPage } from '../../../../../../../website/pages/plugins/components/NgForPluginCompPage/NgForPluginCompPage';
import { NgIfPluginCompPage } from '../../../../../../../website/pages/plugins/components/NgIfPluginCompPage/NgIfPluginCompPage';
import { PagePluginCompPage } from '../../../../../../../website/pages/plugins/components/PagePluginCompPage/PagePluginCompPage';
import { ParagraphPluginCompPage } from '../../../../../../../website/pages/plugins/components/ParagraphPluginCompPage/ParagraphPluginCompPage';
import { PieChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/PieChartPluginCompPage/PieChartPluginCompPage';
import { RadarChartPluginCompPage } from '../../../../../../../website/pages/plugins/components/RadarChartPluginCompPage/RadarChartPluginCompPage';
import { RouterLinkPluginCompPage } from '../../../../../../../website/pages/plugins/components/RouterLinkPluginCompPage/RouterLinkPluginCompPage';
import { RouterOutletPluginCompPage } from '../../../../../../../website/pages/plugins/components/RouterOutletPluginCompPage/RouterOutletPluginCompPage';
import { SiteCallIntercepterPluginCompPage } from '../../../../../../../website/pages/plugins/components/SiteCallIntercepterPluginCompPage/SiteCallIntercepterPluginCompPage';
import { StompServerPluginCompPage } from '../../../../../../../website/pages/plugins/components/StompServerPluginCompPage/StompServerPluginCompPage';
import { TablePluginCompPage } from '../../../../../../../website/pages/plugins/components/TablePluginCompPage/TablePluginCompPage';
import { ThemifyIconPluginCompPage } from '../../../../../../../website/pages/plugins/components/ThemifyIconPluginCompPage/ThemifyIconPluginCompPage';
import { ThemifyIconsPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/ThemifyIconsPageConfiguratorPluginCompPage/ThemifyIconsPageConfiguratorPluginCompPage';
import { ThemifyIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/ThemifyIconsPluginCompPage/ThemifyIconsPluginCompPage';
import { TypeScriptCompilerPluginCompPage } from '../../../../../../../website/pages/plugins/components/TypeScriptCompilerPluginCompPage/TypeScriptCompilerPluginCompPage';
import { WaAsidePluginCompPage } from '../../../../../../../website/pages/plugins/components/WaAsidePluginCompPage/WaAsidePluginCompPage';
import { WaBannerPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaBannerPluginCompPage/WaBannerPluginCompPage';
import { WaButtonPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaButtonPluginCompPage/WaButtonPluginCompPage';
import { WaCardPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaCardPluginCompPage/WaCardPluginCompPage';
import { WaClusterPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaClusterPluginCompPage/WaClusterPluginCompPage';
import { WaDividerPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaDividerPluginCompPage/WaDividerPluginCompPage';
import { WaFooterPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaFooterPluginCompPage/WaFooterPluginCompPage';
import { WaGridPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaGridPluginCompPage/WaGridPluginCompPage';
import { WaHeaderPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaHeaderPluginCompPage/WaHeaderPluginCompPage';
import { WaMainPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaMainPluginCompPage/WaMainPluginCompPage';
import { WaNavigationPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaNavigationPluginCompPage/WaNavigationPluginCompPage';
import { WaPagePluginCompPage } from '../../../../../../../website/pages/plugins/components/WaPagePluginCompPage/WaPagePluginCompPage';
import { WaStackPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaStackPluginCompPage/WaStackPluginCompPage';
import { WaTabsPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaTabsPluginCompPage/WaTabsPluginCompPage';
import { WaTagPluginCompPage } from '../../../../../../../website/pages/plugins/components/WaTagPluginCompPage/WaTagPluginCompPage';
import { WavesApplyToSelectorFeaturePluginCompPage } from '../../../../../../../website/pages/plugins/components/WavesApplyToSelectorFeaturePluginCompPage/WavesApplyToSelectorFeaturePluginCompPage';
import { WavesAttachFeaturePluginCompPage } from '../../../../../../../website/pages/plugins/components/WavesAttachFeaturePluginCompPage/WavesAttachFeaturePluginCompPage';
import { WavesEffectPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/WavesEffectPageConfiguratorPluginCompPage/WavesEffectPageConfiguratorPluginCompPage';
import { WavesEffectsInclusionModulePluginCompPage } from '../../../../../../../website/pages/plugins/components/WavesEffectsInclusionModulePluginCompPage/WavesEffectsInclusionModulePluginCompPage';
import { WavesEffectsPluginCompPage } from '../../../../../../../website/pages/plugins/components/WavesEffectsPluginCompPage/WavesEffectsPluginCompPage';
import { WeatherIconPluginCompPage } from '../../../../../../../website/pages/plugins/components/WeatherIconPluginCompPage/WeatherIconPluginCompPage';
import { WeatherIconsPageConfiguratorPluginCompPage } from '../../../../../../../website/pages/plugins/components/WeatherIconsPageConfiguratorPluginCompPage/WeatherIconsPageConfiguratorPluginCompPage';
import { WeatherIconsPluginCompPage } from '../../../../../../../website/pages/plugins/components/WeatherIconsPluginCompPage/WeatherIconsPluginCompPage';
import { ChoosingPatternPage } from '../../../../../../../website/pages/realtime/ChoosingPatternPage/ChoosingPatternPage';
import { CommunicationLayersPage } from '../../../../../../../website/pages/realtime/CommunicationLayersPage/CommunicationLayersPage';
import { DataServicesPage } from '../../../../../../../website/pages/realtime/DataServicesPage/DataServicesPage';
import { RabbitMQCodeSamplesPage } from '../../../../../../../website/pages/realtime/RabbitMQCodeSamplesPage/RabbitMQCodeSamplesPage';
import { RabbitMQPage } from '../../../../../../../website/pages/realtime/RabbitMQPage/RabbitMQPage';
import { RestAndAjaxPage } from '../../../../../../../website/pages/realtime/RestAndAjaxPage/RestAndAjaxPage';
import { UseCasesPage } from '../../../../../../../website/pages/realtime/UseCasesPage/UseCasesPage';
import { VertxCodeSamplesPage } from '../../../../../../../website/pages/realtime/VertxCodeSamplesPage/VertxCodeSamplesPage';
import { VertxEventBusPage } from '../../../../../../../website/pages/realtime/VertxEventBusPage/VertxEventBusPage';
export const routes: Routes = [ {
  "path" : "",
  "redirectTo" : "home",
  "pathMatch" : "full"
}, {
  "path" : "architecture",
  "component" : ArchitecturePage
}, {
  "path" : "capabilities",
  "component" : CapabilitiesPage
}, {
  "path" : "getting-started",
  "component" : GettingStartedPage
}, {
  "path" : "home",
  "component" : HomePage
}, {
  "path" : "plugins",
  "component" : PluginsPage
}, {
  "path" : "real-time",
  "component" : RealTimePage
}, {
  "path" : "about",
  "outlet" : "aside",
  "component" : AboutAsidePage
}, {
  "path" : "about",
  "component" : AboutPage
}, {
  "path" : "architecture/build-pipeline",
  "component" : BuildPipelinePage
}, {
  "path" : "architecture/data-flow",
  "component" : DataFlowPage
}, {
  "path" : "architecture/module-graph",
  "component" : ModuleGraphPage
}, {
  "path" : "architecture/runtime",
  "component" : RuntimePage
}, {
  "path" : "architecture/stack",
  "component" : StackDiagramPage
}, {
  "path" : "architecture",
  "outlet" : "aside",
  "component" : ArchitectureAsidePage
}, {
  "path" : "capabilities",
  "outlet" : "aside",
  "component" : CapabilitiesAsidePage
}, {
  "path" : "frameworks",
  "outlet" : "aside",
  "component" : FrameworksAsidePage
}, {
  "path" : "plugins",
  "outlet" : "aside",
  "component" : PluginsAsidePage
}, {
  "path" : "real-time",
  "outlet" : "aside",
  "component" : RealTimeAsidePage
}, {
  "path" : "capabilities/angular-generation",
  "component" : AngularGenerationPage
}, {
  "path" : "capabilities/event-system",
  "component" : EventSystemPage
}, {
  "path" : "capabilities/plugin-model",
  "component" : PluginModelPage
}, {
  "path" : "capabilities/real-time-messaging",
  "component" : RealTimeMessagingPage
}, {
  "path" : "capabilities/rendering",
  "component" : RenderingPage
}, {
  "path" : "capabilities/spi-extensibility",
  "component" : SpiExtensibilityPage
}, {
  "path" : "frameworks/angular-material",
  "component" : AngularMaterialFrameworkPage
}, {
  "path" : "frameworks/bootstrap",
  "component" : BootstrapFrameworkPage
}, {
  "path" : "frameworks",
  "component" : FrameworksPage
}, {
  "path" : "frameworks/jquery-ui",
  "component" : JQueryUIFrameworkPage
}, {
  "path" : "frameworks/web-awesome",
  "component" : WebAwesomeFrameworkPage
}, {
  "path" : "frameworks/web-awesome-pro",
  "component" : WebAwesomeProFrameworkPage
}, {
  "path" : "frameworks/bootstrap/bsaccordion",
  "component" : BSAccordionPage
}, {
  "path" : "frameworks/bootstrap/bsalert",
  "component" : BSAlertPage
}, {
  "path" : "frameworks/bootstrap/bsbadge",
  "component" : BSBadgePage
}, {
  "path" : "frameworks/bootstrap/bsbreadcrumb-container",
  "component" : BSBreadcrumbContainerPage
}, {
  "path" : "frameworks/bootstrap/bsbutton-group",
  "component" : BSButtonGroupPage
}, {
  "path" : "frameworks/bootstrap/bsbutton",
  "component" : BSButtonPage
}, {
  "path" : "frameworks/bootstrap/bscard",
  "component" : BSCardPage
}, {
  "path" : "frameworks/bootstrap/bscarousel",
  "component" : BSCarouselPage
}, {
  "path" : "frameworks/bootstrap/bscheck-box",
  "component" : BSCheckBoxPage
}, {
  "path" : "frameworks/bootstrap/bsclose-icon",
  "component" : BSCloseIconPage
}, {
  "path" : "frameworks/bootstrap/bscollapse",
  "component" : BSCollapsePage
}, {
  "path" : "frameworks/bootstrap/bscontainer",
  "component" : BSContainerPage
}, {
  "path" : "frameworks/bootstrap/bsdate-picker",
  "component" : BSDatePickerPage
}, {
  "path" : "frameworks/bootstrap/bsdrop-down",
  "component" : BSDropDownPage
}, {
  "path" : "frameworks/bootstrap/bsfigure",
  "component" : BSFigurePage
}, {
  "path" : "frameworks/bootstrap/bsfile-upload",
  "component" : BSFileUploadPage
}, {
  "path" : "frameworks/bootstrap/bsform",
  "component" : BSFormPage
}, {
  "path" : "frameworks/bootstrap/bsimage",
  "component" : BSImagePage
}, {
  "path" : "frameworks/bootstrap/bsjumbotron",
  "component" : BSJumbotronPage
}, {
  "path" : "frameworks/bootstrap/bslist-group",
  "component" : BSListGroupPage
}, {
  "path" : "frameworks/bootstrap/bsmedia",
  "component" : BSMediaPage
}, {
  "path" : "frameworks/bootstrap/bsmodal",
  "component" : BSModalPage
}, {
  "path" : "frameworks/bootstrap/bsnav-bar",
  "component" : BSNavBarPage
}, {
  "path" : "frameworks/bootstrap/bsnavs",
  "component" : BSNavsPage
}, {
  "path" : "frameworks/bootstrap/bspagination",
  "component" : BSPaginationPage
}, {
  "path" : "frameworks/bootstrap/bspop-over",
  "component" : BSPopOverPage
}, {
  "path" : "frameworks/bootstrap/bsprogress-bar",
  "component" : BSProgressBarPage
}, {
  "path" : "frameworks/bootstrap/bsradio-button",
  "component" : BSRadioButtonPage
}, {
  "path" : "frameworks/bootstrap/bsrange",
  "component" : BSRangePage
}, {
  "path" : "frameworks/bootstrap/bsselect",
  "component" : BSSelectPage
}, {
  "path" : "frameworks/bootstrap/bsswitch",
  "component" : BSSwitchPage
}, {
  "path" : "frameworks/bootstrap/bstable",
  "component" : BSTablePage
}, {
  "path" : "frameworks/bootstrap/bstime-picker",
  "component" : BSTimePickerPage
}, {
  "path" : "frameworks/bootstrap/bstoast",
  "component" : BSToastPage
}, {
  "path" : "frameworks/bootstrap/bstoggle",
  "component" : BSTogglePage
}, {
  "path" : "frameworks/jquery-ui/jquiaccordion",
  "component" : JQUIAccordionPage
}, {
  "path" : "frameworks/jquery-ui/jquiauto-complete",
  "component" : JQUIAutoCompletePage
}, {
  "path" : "frameworks/jquery-ui/jquibutton",
  "component" : JQUIButtonPage
}, {
  "path" : "frameworks/jquery-ui/jquicheck-box-group",
  "component" : JQUICheckBoxGroupPage
}, {
  "path" : "frameworks/jquery-ui/jquidate-picker",
  "component" : JQUIDatePickerPage
}, {
  "path" : "frameworks/jquery-ui/jquidialog",
  "component" : JQUIDialogPage
}, {
  "path" : "frameworks/jquery-ui/jquidraggable",
  "component" : JQUIDraggablePage
}, {
  "path" : "frameworks/jquery-ui/jquidroppable",
  "component" : JQUIDroppablePage
}, {
  "path" : "frameworks/jquery-ui/jquimenu",
  "component" : JQUIMenuPage
}, {
  "path" : "frameworks/jquery-ui/jquiprogress-bar",
  "component" : JQUIProgressBarPage
}, {
  "path" : "frameworks/jquery-ui/jquiresizable",
  "component" : JQUIResizablePage
}, {
  "path" : "frameworks/jquery-ui/jquiselect-menu",
  "component" : JQUISelectMenuPage
}, {
  "path" : "frameworks/jquery-ui/jquiselectable",
  "component" : JQUISelectablePage
}, {
  "path" : "frameworks/jquery-ui/jquislider",
  "component" : JQUISliderPage
}, {
  "path" : "frameworks/jquery-ui/jquisortable",
  "component" : JQUISortablePage
}, {
  "path" : "frameworks/jquery-ui/jquispinner",
  "component" : JQUISpinnerPage
}, {
  "path" : "frameworks/jquery-ui/jquitabs",
  "component" : JQUITabsPage
}, {
  "path" : "frameworks/jquery-ui/jquitooltip",
  "component" : JQUITooltipPage
}, {
  "path" : "frameworks/angular-material/mat-accordion",
  "component" : MatAccordionPage
}, {
  "path" : "frameworks/angular-material/mat-auto-complete",
  "component" : MatAutoCompletePage
}, {
  "path" : "frameworks/angular-material/mat-button",
  "component" : MatButtonPage
}, {
  "path" : "frameworks/angular-material/mat-checkbox",
  "component" : MatCheckboxPage
}, {
  "path" : "frameworks/angular-material/mat-chip-auto-complete",
  "component" : MatChipAutoCompletePage
}, {
  "path" : "frameworks/angular-material/mat-dialog",
  "component" : MatDialogPage
}, {
  "path" : "frameworks/angular-material/mat-form-field",
  "component" : MatFormFieldPage
}, {
  "path" : "frameworks/angular-material/mat-icon",
  "component" : MatIconPage
}, {
  "path" : "frameworks/angular-material/mat-progress-bar",
  "component" : MatProgressBarPage
}, {
  "path" : "frameworks/angular-material/mat-select",
  "component" : MatSelectPage
}, {
  "path" : "frameworks/angular-material/mat-table",
  "component" : MatTablePage
}, {
  "path" : "frameworks/angular-material/mat-table-paginator",
  "component" : MatTablePaginatorPage
}, {
  "path" : "frameworks/web-awesome/wa-animated-image",
  "component" : WaAnimatedImagePage
}, {
  "path" : "frameworks/web-awesome/wa-animation",
  "component" : WaAnimationPage
}, {
  "path" : "frameworks/web-awesome/wa-avatar-group",
  "component" : WaAvatarGroupPage
}, {
  "path" : "frameworks/web-awesome/wa-avatar",
  "component" : WaAvatarPage
}, {
  "path" : "frameworks/web-awesome/wa-badge",
  "component" : WaBadgePage
}, {
  "path" : "frameworks/web-awesome-pro/wa-bar-chart",
  "component" : WaBarChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-breadcrumb-item",
  "component" : WaBreadcrumbItemPage
}, {
  "path" : "frameworks/web-awesome/wa-breadcrumbs",
  "component" : WaBreadcrumbsPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-bubble-chart",
  "component" : WaBubbleChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-button-group",
  "component" : WaButtonGroupPage
}, {
  "path" : "frameworks/web-awesome/wa-button",
  "component" : WaButtonPage
}, {
  "path" : "frameworks/web-awesome/wa-callout",
  "component" : WaCalloutPage
}, {
  "path" : "frameworks/web-awesome/wa-card",
  "component" : WaCardPage
}, {
  "path" : "frameworks/web-awesome/wa-carousel-item",
  "component" : WaCarouselItemPage
}, {
  "path" : "frameworks/web-awesome/wa-carousel",
  "component" : WaCarouselPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-chart",
  "component" : WaChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-checkbox",
  "component" : WaCheckboxPage
}, {
  "path" : "frameworks/web-awesome/wa-cluster",
  "component" : WaClusterPage
}, {
  "path" : "frameworks/web-awesome/wa-color-picker",
  "component" : WaColorPickerPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-combobox",
  "component" : WaComboboxProPage
}, {
  "path" : "frameworks/web-awesome/wa-comparison",
  "component" : WaComparisonPage
}, {
  "path" : "frameworks/web-awesome/wa-copy-button",
  "component" : WaCopyButtonPage
}, {
  "path" : "frameworks/web-awesome/wa-details",
  "component" : WaDetailsPage
}, {
  "path" : "frameworks/web-awesome/wa-dialog",
  "component" : WaDialogPage
}, {
  "path" : "frameworks/web-awesome/wa-div",
  "component" : WaDivPage
}, {
  "path" : "frameworks/web-awesome/wa-divider",
  "component" : WaDividerPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-doughnut-chart",
  "component" : WaDoughnutChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-drawer",
  "component" : WaDrawerPage
}, {
  "path" : "frameworks/web-awesome/wa-drop-down",
  "component" : WaDropDownPage
}, {
  "path" : "frameworks/web-awesome/wa-dropdown-item",
  "component" : WaDropdownItemPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-file-input",
  "component" : WaFileInputProPage
}, {
  "path" : "frameworks/web-awesome/wa-flank",
  "component" : WaFlankPage
}, {
  "path" : "frameworks/web-awesome/wa-format-bytes",
  "component" : WaFormatBytesPage
}, {
  "path" : "frameworks/web-awesome/wa-format-date",
  "component" : WaFormatDatePage
}, {
  "path" : "frameworks/web-awesome/wa-format-number",
  "component" : WaFormatNumberPage
}, {
  "path" : "frameworks/web-awesome/wa-frame",
  "component" : WaFramePage
}, {
  "path" : "frameworks/web-awesome/wa-grid",
  "component" : WaGridPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-icon-fa",
  "component" : WaIconFAProPage
}, {
  "path" : "frameworks/web-awesome/wa-icon",
  "component" : WaIconPage
}, {
  "path" : "frameworks/web-awesome/wa-image-compare",
  "component" : WaImageComparePage
}, {
  "path" : "frameworks/web-awesome/wa-include",
  "component" : WaIncludePage
}, {
  "path" : "frameworks/web-awesome/wa-input",
  "component" : WaInputPage
}, {
  "path" : "frameworks/web-awesome/wa-intersection-observer",
  "component" : WaIntersectionObserverPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-line-chart",
  "component" : WaLineChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-markdown",
  "component" : WaMarkdownPage
}, {
  "path" : "frameworks/web-awesome/wa-mutation-observer",
  "component" : WaMutationObserverPage
}, {
  "path" : "frameworks/web-awesome/wa-number-input",
  "component" : WaNumberInputPage
}, {
  "path" : "frameworks/web-awesome/wa-page-banner",
  "component" : WaPageBannerProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-content",
  "component" : WaPageContentProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-aside",
  "component" : WaPageContentsAsideProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-main-footer",
  "component" : WaPageContentsMainFooterProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-main-header",
  "component" : WaPageContentsMainHeaderProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-main",
  "component" : WaPageContentsMainProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-navigation-footer",
  "component" : WaPageContentsNavigationFooterProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-navigation-header",
  "component" : WaPageContentsNavigationHeaderProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-contents-navigation",
  "component" : WaPageContentsNavigationProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-dialog-wrapper",
  "component" : WaPageDialogWrapperProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-footer",
  "component" : WaPageFooterProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-header",
  "component" : WaPageHeaderProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-menu",
  "component" : WaPageMenuProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-navigation-toggle-icon",
  "component" : WaPageNavigationToggleIconProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-navigation-toggle",
  "component" : WaPageNavigationToggleProPage
}, {
  "path" : "frameworks/web-awesome/wa-page",
  "component" : WaPageProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-skip-to-content",
  "component" : WaPageSkipToContentProPage
}, {
  "path" : "frameworks/web-awesome/wa-page-sub-header",
  "component" : WaPageSubHeaderProPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-pie-chart",
  "component" : WaPieChartProPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-polar-area-chart",
  "component" : WaPolarAreaChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-popover",
  "component" : WaPopoverPage
}, {
  "path" : "frameworks/web-awesome/wa-popup",
  "component" : WaPopupPage
}, {
  "path" : "frameworks/web-awesome/wa-progress-bar",
  "component" : WaProgressBarPage
}, {
  "path" : "frameworks/web-awesome/wa-progress-ring",
  "component" : WaProgressRingPage
}, {
  "path" : "frameworks/web-awesome/wa-qrcode",
  "component" : WaQRCodePage
}, {
  "path" : "frameworks/web-awesome-pro/wa-radar-chart",
  "component" : WaRadarChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-radio-group",
  "component" : WaRadioGroupPage
}, {
  "path" : "frameworks/web-awesome/wa-radio",
  "component" : WaRadioPage
}, {
  "path" : "frameworks/web-awesome/wa-range",
  "component" : WaRangePage
}, {
  "path" : "frameworks/web-awesome/wa-rating",
  "component" : WaRatingPage
}, {
  "path" : "frameworks/web-awesome/wa-relative-time",
  "component" : WaRelativeTimePage
}, {
  "path" : "frameworks/web-awesome/wa-resize-observer",
  "component" : WaResizeObserverPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-scatter-chart",
  "component" : WaScatterChartProPage
}, {
  "path" : "frameworks/web-awesome/wa-scroller",
  "component" : WaScrollerPage
}, {
  "path" : "frameworks/web-awesome/wa-select-option",
  "component" : WaSelectOptionPage
}, {
  "path" : "frameworks/web-awesome/wa-select",
  "component" : WaSelectPage
}, {
  "path" : "frameworks/web-awesome/wa-skeleton",
  "component" : WaSkeletonPage
}, {
  "path" : "frameworks/web-awesome-pro/wa-sparkline",
  "component" : WaSparklineProPage
}, {
  "path" : "frameworks/web-awesome/wa-spinner",
  "component" : WaSpinnerPage
}, {
  "path" : "frameworks/web-awesome/wa-split-button",
  "component" : WaSplitButtonPage
}, {
  "path" : "frameworks/web-awesome/wa-split",
  "component" : WaSplitPage
}, {
  "path" : "frameworks/web-awesome/wa-split-panel",
  "component" : WaSplitPanelPage
}, {
  "path" : "frameworks/web-awesome/wa-stack",
  "component" : WaStackPage
}, {
  "path" : "frameworks/web-awesome/wa-switch",
  "component" : WaSwitchPage
}, {
  "path" : "frameworks/web-awesome/wa-tab-group",
  "component" : WaTabGroupPage
}, {
  "path" : "frameworks/web-awesome/wa-tab",
  "component" : WaTabPage
}, {
  "path" : "frameworks/web-awesome/wa-tab-panel",
  "component" : WaTabPanelPage
}, {
  "path" : "frameworks/web-awesome/wa-tag",
  "component" : WaTagPage
}, {
  "path" : "frameworks/web-awesome/wa-text-area",
  "component" : WaTextAreaPage
}, {
  "path" : "frameworks/web-awesome/wa-text",
  "component" : WaTextPage
}, {
  "path" : "frameworks/web-awesome/wa-toast-container",
  "component" : WaToastContainerPage
}, {
  "path" : "frameworks/web-awesome/wa-toast-data-service",
  "component" : WaToastDataServicePage
}, {
  "path" : "frameworks/web-awesome/wa-toast-item",
  "component" : WaToastItemPage
}, {
  "path" : "frameworks/web-awesome/wa-tooltip",
  "component" : WaTooltipPage
}, {
  "path" : "frameworks/web-awesome/wa-tree-item",
  "component" : WaTreeItemPage
}, {
  "path" : "frameworks/web-awesome/wa-tree",
  "component" : WaTreePage
}, {
  "path" : "frameworks/web-awesome/wa-zoomable-frame",
  "component" : WaZoomableFramePage
}, {
  "path" : "getting-started/application",
  "component" : ApplicationPage
}, {
  "path" : "getting-started/build-and-run",
  "component" : BuildAndRunPage
}, {
  "path" : "getting-started",
  "outlet" : "aside",
  "component" : GettingStartedAsidePage
}, {
  "path" : "getting-started/next-steps",
  "component" : NextStepsPage
}, {
  "path" : "getting-started/whats-happening",
  "component" : WhatsHappeningPage
}, {
  "path" : "home",
  "outlet" : "aside",
  "component" : HomeAsidePage
}, {
  "path" : "dashboard",
  "component" : SalesDashboard
}, {
  "path" : "plugins/agcharts-enterprise",
  "component" : AgChartsEnterprisePluginPage
}, {
  "path" : "plugins/agcharts",
  "component" : AgChartsPluginPage
}, {
  "path" : "plugins/aggrid-enterprise",
  "component" : AgGridEnterprisePluginPage
}, {
  "path" : "plugins/aggrid",
  "component" : AgGridPluginPage
}, {
  "path" : "plugins/angular-maven-plugin",
  "component" : AngularMavenPluginPage
}, {
  "path" : "plugins/angular",
  "component" : AngularPluginPage
}, {
  "path" : "plugins/bootstrap",
  "component" : BootstrapPluginPage
}, {
  "path" : "plugins/c3",
  "component" : C3PluginPage
}, {
  "path" : "plugins/chartjs",
  "component" : ChartJsPluginPage
}, {
  "path" : "plugins/client",
  "component" : ClientPluginPage
}, {
  "path" : "plugins/core",
  "component" : CorePluginPage
}, {
  "path" : "plugins/d3",
  "component" : D3PluginPage
}, {
  "path" : "plugins/datatables",
  "component" : DataTablesPluginPage
}, {
  "path" : "plugins/easing",
  "component" : EasingPluginPage
}, {
  "path" : "plugins/easy-pie-chart",
  "component" : EasyPieChartPluginPage
}, {
  "path" : "plugins/fontawesome",
  "component" : FontAwesomePluginPage
}, {
  "path" : "plugins/fontawesome-pro",
  "component" : FontAwesomeProPluginPage
}, {
  "path" : "plugins/fullcalendar",
  "component" : FullCalendarPluginPage
}, {
  "path" : "plugins/fullcalendar-pro",
  "component" : FullCalendarProPluginPage
}, {
  "path" : "plugins/globalize",
  "component" : GlobalizePluginPage
}, {
  "path" : "plugins/glyphicons",
  "component" : GlyphiconsPluginPage
}, {
  "path" : "plugins/jqplot",
  "component" : JQPlotPluginPage
}, {
  "path" : "plugins/jquery",
  "component" : JQueryPluginPage
}, {
  "path" : "plugins/jquery-ui",
  "component" : JQueryUIPluginPage
}, {
  "path" : "plugins/localstorage",
  "component" : LocalStoragePluginPage
}, {
  "path" : "plugins/material-design-icons",
  "component" : MaterialDesignIconsPluginPage
}, {
  "path" : "plugins/material-icons",
  "component" : MaterialIconsPluginPage
}, {
  "path" : "plugins/plus-as-tab",
  "component" : PlusAsTabPluginPage
}, {
  "path" : "plugins/prettify",
  "component" : PrettifyPluginPage
}, {
  "path" : "plugins/rabbitmq",
  "component" : RabbitMQPluginPage
}, {
  "path" : "plugins/sessionstorage",
  "component" : SessionStoragePluginPage
}, {
  "path" : "plugins/skycons",
  "component" : SkyconsPluginPage
}, {
  "path" : "plugins/themify-icons",
  "component" : ThemifyIconsPluginPage
}, {
  "path" : "plugins/toastr",
  "component" : ToastrPluginPage
}, {
  "path" : "plugins/typescript-client",
  "component" : TypeScriptClientPluginPage
}, {
  "path" : "plugins/vertx",
  "component" : VertxPluginPage
}, {
  "path" : "plugins/waves",
  "component" : WavesEffectPluginPage
}, {
  "path" : "plugins/waypoints",
  "component" : WayPointsPluginPage
}, {
  "path" : "plugins/weather-icons",
  "component" : WeatherIconsPluginPage
}, {
  "path" : "plugins/web-awesome",
  "component" : WebAwesomePluginPage
}, {
  "path" : "plugins/web-awesome-pro",
  "component" : WebAwesomeProPluginPage
}, {
  "path" : "plugins/agcharts/ag-area-chart",
  "component" : AgAreaChartPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-bar-chart",
  "component" : AgBarChartPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-bubble-chart",
  "component" : AgBubbleChartPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-candlestick-series-options",
  "component" : AgCandlestickSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-chart-options",
  "component" : AgChartOptionsPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-chart",
  "component" : AgChartPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-chord-series-options",
  "component" : AgChordSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-combination-chart",
  "component" : AgCombinationChartPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-donut-chart",
  "component" : AgDonutChartPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-funnel-series-options",
  "component" : AgFunnelSeriesPluginCompPage
}, {
  "path" : "plugins/aggrid/ag-grid-column-def",
  "component" : AgGridColumnDefPluginCompPage
}, {
  "path" : "plugins/aggrid-enterprise/ag-grid-enterprise-column-def",
  "component" : AgGridEnterpriseColumnDefPluginCompPage
}, {
  "path" : "plugins/aggrid-enterprise/ag-grid-enterprise-options",
  "component" : AgGridEnterpriseOptionsPluginCompPage
}, {
  "path" : "plugins/aggrid/ag-grid-options",
  "component" : AgGridOptionsPluginCompPage
}, {
  "path" : "plugins/aggrid/ag-grid",
  "component" : AgGridPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-heatmap-series-options",
  "component" : AgHeatmapSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-histogram-series-options",
  "component" : AgHistogramSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-line-chart",
  "component" : AgLineChartPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-nightingale-series-options",
  "component" : AgNightingaleSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-ohlc-series-options",
  "component" : AgOhlcSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-pie-chart",
  "component" : AgPieChartPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-radar-area-series-options",
  "component" : AgRadarAreaSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-radar-line-series-options",
  "component" : AgRadarLineSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-radial-bar-series-options",
  "component" : AgRadialBarSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-radial-column-series-options",
  "component" : AgRadialColumnSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-range-area-series-options",
  "component" : AgRangeAreaSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-range-bar-series-options",
  "component" : AgRangeBarSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-sankey-series-options",
  "component" : AgSankeySeriesPluginCompPage
}, {
  "path" : "plugins/agcharts/ag-scatter-chart",
  "component" : AgScatterChartPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-sunburst-series-options",
  "component" : AgSunburstSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-treemap-series-options",
  "component" : AgTreemapSeriesPluginCompPage
}, {
  "path" : "plugins/agcharts-enterprise/ag-waterfall-series-options",
  "component" : AgWaterfallSeriesPluginCompPage
}, {
  "path" : "plugins/client/ajax-call-intercepter",
  "component" : AjaxCallIntercepterPluginCompPage
}, {
  "path" : "plugins/client/ajax-call",
  "component" : AjaxCallPluginCompPage
}, {
  "path" : "plugins/client/ajax-response",
  "component" : AjaxResponsePluginCompPage
}, {
  "path" : "plugins/bootstrap/bsaccordion",
  "component" : BSAccordionPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsalert",
  "component" : BSAlertPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsbadge",
  "component" : BSBadgePluginCompPage
}, {
  "path" : "plugins/bootstrap/bsbreadcrumb-container",
  "component" : BSBreadcrumbContainerPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsbutton-group",
  "component" : BSButtonGroupPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsbutton",
  "component" : BSButtonPluginCompPage
}, {
  "path" : "plugins/bootstrap/bscard",
  "component" : BSCardPluginCompPage
}, {
  "path" : "plugins/bootstrap/bscarousel",
  "component" : BSCarouselPluginCompPage
}, {
  "path" : "plugins/bootstrap/bscheck-box",
  "component" : BSCheckBoxPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsclose-icon",
  "component" : BSCloseIconPluginCompPage
}, {
  "path" : "plugins/bootstrap/bscollapse",
  "component" : BSCollapsePluginCompPage
}, {
  "path" : "plugins/bootstrap/bscontainer",
  "component" : BSContainerPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsdate-picker",
  "component" : BSDatePickerPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsdrop-down",
  "component" : BSDropDownPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsfigure",
  "component" : BSFigurePluginCompPage
}, {
  "path" : "plugins/bootstrap/bsfile-upload",
  "component" : BSFileUploadPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsform",
  "component" : BSFormPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsimage",
  "component" : BSImagePluginCompPage
}, {
  "path" : "plugins/bootstrap/bsjumbotron",
  "component" : BSJumbotronPluginCompPage
}, {
  "path" : "plugins/bootstrap/bslist-group",
  "component" : BSListGroupPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsmedia",
  "component" : BSMediaPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsmodal",
  "component" : BSModalPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsnav-bar",
  "component" : BSNavBarPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsnavs",
  "component" : BSNavsPluginCompPage
}, {
  "path" : "plugins/bootstrap/bspagination",
  "component" : BSPaginationPluginCompPage
}, {
  "path" : "plugins/bootstrap/bspop-over",
  "component" : BSPopOverPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsprogress-bar",
  "component" : BSProgressBarPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsradio-button",
  "component" : BSRadioButtonPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsrange",
  "component" : BSRangePluginCompPage
}, {
  "path" : "plugins/bootstrap/bsselect",
  "component" : BSSelectPluginCompPage
}, {
  "path" : "plugins/bootstrap/bsswitch",
  "component" : BSSwitchPluginCompPage
}, {
  "path" : "plugins/bootstrap/bstable",
  "component" : BSTablePluginCompPage
}, {
  "path" : "plugins/bootstrap/bstime-picker",
  "component" : BSTimePickerPluginCompPage
}, {
  "path" : "plugins/bootstrap/bstoast",
  "component" : BSToastPluginCompPage
}, {
  "path" : "plugins/bootstrap/bstoggle",
  "component" : BSTogglePluginCompPage
}, {
  "path" : "plugins/chartjs/bar-chart",
  "component" : BarChartPluginCompPage
}, {
  "path" : "plugins/client/data-call-intercepter",
  "component" : DataCallIntercepterPluginCompPage
}, {
  "path" : "plugins/datatables/data-table-column-options",
  "component" : DataTableColumnOptionsPluginCompPage
}, {
  "path" : "plugins/datatables/data-table-options",
  "component" : DataTableOptionsPluginCompPage
}, {
  "path" : "plugins/datatables/data-table-page-configurator",
  "component" : DataTablePageConfiguratorPluginCompPage
}, {
  "path" : "plugins/datatables/data-table",
  "component" : DataTablePluginCompPage
}, {
  "path" : "plugins/datatables/data-tables-buttons-options",
  "component" : DataTablesButtonsOptionsPluginCompPage
}, {
  "path" : "plugins/datatables/data-tables-responsive-options",
  "component" : DataTablesResponsiveOptionsPluginCompPage
}, {
  "path" : "plugins/core/div-simple",
  "component" : DivSimplePluginCompPage
}, {
  "path" : "plugins/chartjs/doughnut-chart",
  "component" : DoughnutChartPluginCompPage
}, {
  "path" : "plugins/core/feature",
  "component" : FeaturePluginCompPage
}, {
  "path" : "plugins/fontawesome-pro/font-awesome5-families",
  "component" : FontAwesome5FamiliesPluginCompPage
}, {
  "path" : "plugins/fontawesome-pro/font-awesome5-pro-icons",
  "component" : FontAwesome5ProIconsPluginCompPage
}, {
  "path" : "plugins/fontawesome-pro/font-awesome5-pro-page-configurator",
  "component" : FontAwesome5ProPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/fontawesome-pro/font-awesome5-pro-styles",
  "component" : FontAwesome5ProStylesPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-brand-icons",
  "component" : FontAwesomeBrandIconsPluginCompPage
}, {
  "path" : "plugins/fontawesome-pro/font-awesome-duotone",
  "component" : FontAwesomeDuotonePluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-icons",
  "component" : FontAwesomeIconsPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-layer-counter",
  "component" : FontAwesomeLayerCounterPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-layer-text",
  "component" : FontAwesomeLayerTextPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-layers",
  "component" : FontAwesomeLayersPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-list",
  "component" : FontAwesomeListPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome",
  "component" : FontAwesomePluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-sizes",
  "component" : FontAwesomeSizesPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-styles",
  "component" : FontAwesomeStylesPluginCompPage
}, {
  "path" : "plugins/fontawesome/font-awesome-transforms",
  "component" : FontAwesomeTransformsPluginCompPage
}, {
  "path" : "plugins/core/form",
  "component" : FormPluginCompPage
}, {
  "path" : "plugins/fullcalendar/full-calendar-event",
  "component" : FullCalendarEventPluginCompPage
}, {
  "path" : "plugins/fullcalendar/full-calendar-options",
  "component" : FullCalendarOptionsPluginCompPage
}, {
  "path" : "plugins/fullcalendar/full-calendar",
  "component" : FullCalendarPluginCompPage
}, {
  "path" : "plugins/fullcalendar-pro/full-calendar-pro",
  "component" : FullCalendarProPluginCompPage
}, {
  "path" : "plugins/glyphicons/glyphicon",
  "component" : GlyphiconPluginCompPage
}, {
  "path" : "plugins/glyphicons/glyphicons-page-configurator",
  "component" : GlyphiconsPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/glyphicons/glyphicons",
  "component" : GlyphiconsPluginCompPage
}, {
  "path" : "plugins/client/ipage-configurator",
  "component" : IPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/client/ipage",
  "component" : IPagePluginCompPage
}, {
  "path" : "plugins/fontawesome-pro/icon-family",
  "component" : IconFamilyPluginCompPage
}, {
  "path" : "plugins/core/input-text-type",
  "component" : InputTextTypePluginCompPage
}, {
  "path" : "plugins/easing/jqeasing-effects",
  "component" : JQEasingEffectsPluginCompPage
}, {
  "path" : "plugins/easing/jqeasing-page-configurator",
  "component" : JQEasingPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquiaccordion",
  "component" : JQUIAccordionPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquiauto-complete",
  "component" : JQUIAutoCompletePluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquibutton",
  "component" : JQUIButtonPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquidate-picker",
  "component" : JQUIDatePickerPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquidialog",
  "component" : JQUIDialogPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquidraggable",
  "component" : JQUIDraggablePluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquidroppable",
  "component" : JQUIDroppablePluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquislider",
  "component" : JQUISliderPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquisortable",
  "component" : JQUISortablePluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquitabs",
  "component" : JQUITabsPluginCompPage
}, {
  "path" : "plugins/jquery-ui/jquitool-tip",
  "component" : JQUIToolTipPluginCompPage
}, {
  "path" : "plugins/jquery/jquery-inclusion-module",
  "component" : JQueryInclusionModulePluginCompPage
}, {
  "path" : "plugins/jquery/jquery-page-configurator",
  "component" : JQueryPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/vertx/jweb-mpajax-servlet",
  "component" : JWebMPAjaxServletPluginCompPage
}, {
  "path" : "plugins/vertx/jweb-mpcssservlet",
  "component" : JWebMPCSSServletPluginCompPage
}, {
  "path" : "plugins/vertx/jweb-mpdata-servlet",
  "component" : JWebMPDataServletPluginCompPage
}, {
  "path" : "plugins/vertx/jweb-mpscript-servlet",
  "component" : JWebMPScriptServletPluginCompPage
}, {
  "path" : "plugins/vertx/jweb-mpvertx-servlet",
  "component" : JWebMPVertxServletPluginCompPage
}, {
  "path" : "plugins/chartjs/line-chart",
  "component" : LineChartPluginCompPage
}, {
  "path" : "plugins/material-icons/mdiicon",
  "component" : MDIIconPluginCompPage
}, {
  "path" : "plugins/material-icons/mdiicons",
  "component" : MDIIconsPluginCompPage
}, {
  "path" : "plugins/material-design-icons/material-design-icon-colours",
  "component" : MaterialDesignIconColoursPluginCompPage
}, {
  "path" : "plugins/material-design-icons/material-design-icon",
  "component" : MaterialDesignIconPluginCompPage
}, {
  "path" : "plugins/material-design-icons/material-design-icon-size",
  "component" : MaterialDesignIconSizePluginCompPage
}, {
  "path" : "plugins/material-design-icons/material-design-icon-themes",
  "component" : MaterialDesignIconThemesPluginCompPage
}, {
  "path" : "plugins/material-design-icons/material-design-icons-page-configurator",
  "component" : MaterialDesignIconsPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/material-design-icons/material-design-icons",
  "component" : MaterialDesignIconsPluginCompPage
}, {
  "path" : "plugins/material-icons/material-icons-page-configurator",
  "component" : MaterialIconsPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/angular/ngapplication",
  "component" : NGApplicationPluginCompPage
}, {
  "path" : "plugins/angular/ng-for",
  "component" : NgForPluginCompPage
}, {
  "path" : "plugins/angular/ng-if",
  "component" : NgIfPluginCompPage
}, {
  "path" : "plugins/core/page",
  "component" : PagePluginCompPage
}, {
  "path" : "plugins/core/paragraph",
  "component" : ParagraphPluginCompPage
}, {
  "path" : "plugins/chartjs/pie-chart",
  "component" : PieChartPluginCompPage
}, {
  "path" : "plugins/chartjs/radar-chart",
  "component" : RadarChartPluginCompPage
}, {
  "path" : "plugins/angular/router-link",
  "component" : RouterLinkPluginCompPage
}, {
  "path" : "plugins/angular/router-outlet",
  "component" : RouterOutletPluginCompPage
}, {
  "path" : "plugins/client/site-call-intercepter",
  "component" : SiteCallIntercepterPluginCompPage
}, {
  "path" : "plugins/angular/stomp-server",
  "component" : StompServerPluginCompPage
}, {
  "path" : "plugins/core/table",
  "component" : TablePluginCompPage
}, {
  "path" : "plugins/themify-icons/themify-icon",
  "component" : ThemifyIconPluginCompPage
}, {
  "path" : "plugins/themify-icons/themify-icons-page-configurator",
  "component" : ThemifyIconsPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/themify-icons/themify-icons",
  "component" : ThemifyIconsPluginCompPage
}, {
  "path" : "plugins/angular/type-script-compiler",
  "component" : TypeScriptCompilerPluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-aside",
  "component" : WaAsidePluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-banner",
  "component" : WaBannerPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-button",
  "component" : WaButtonPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-card",
  "component" : WaCardPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-cluster",
  "component" : WaClusterPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-divider",
  "component" : WaDividerPluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-footer",
  "component" : WaFooterPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-grid",
  "component" : WaGridPluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-header",
  "component" : WaHeaderPluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-main",
  "component" : WaMainPluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-navigation",
  "component" : WaNavigationPluginCompPage
}, {
  "path" : "plugins/web-awesome-pro/wa-page",
  "component" : WaPagePluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-stack",
  "component" : WaStackPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-tabs",
  "component" : WaTabsPluginCompPage
}, {
  "path" : "plugins/web-awesome/wa-tag",
  "component" : WaTagPluginCompPage
}, {
  "path" : "plugins/waves/waves-apply-to-selector-feature",
  "component" : WavesApplyToSelectorFeaturePluginCompPage
}, {
  "path" : "plugins/waves/waves-attach-feature",
  "component" : WavesAttachFeaturePluginCompPage
}, {
  "path" : "plugins/waves/waves-effect-page-configurator",
  "component" : WavesEffectPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/waves/waves-effects-inclusion-module",
  "component" : WavesEffectsInclusionModulePluginCompPage
}, {
  "path" : "plugins/waves/waves-effects",
  "component" : WavesEffectsPluginCompPage
}, {
  "path" : "plugins/weather-icons/weather-icon",
  "component" : WeatherIconPluginCompPage
}, {
  "path" : "plugins/weather-icons/weather-icons-page-configurator",
  "component" : WeatherIconsPageConfiguratorPluginCompPage
}, {
  "path" : "plugins/weather-icons/weather-icons",
  "component" : WeatherIconsPluginCompPage
}, {
  "path" : "real-time/choosing-a-pattern",
  "component" : ChoosingPatternPage
}, {
  "path" : "real-time/communication-layers",
  "component" : CommunicationLayersPage
}, {
  "path" : "real-time/data-services",
  "component" : DataServicesPage
}, {
  "path" : "real-time/rabbitmq-code-samples",
  "component" : RabbitMQCodeSamplesPage
}, {
  "path" : "real-time/rabbitmq",
  "component" : RabbitMQPage
}, {
  "path" : "real-time/rest-and-ajax",
  "component" : RestAndAjaxPage
}, {
  "path" : "real-time/use-cases",
  "component" : UseCasesPage
}, {
  "path" : "real-time/vertx-code-samples",
  "component" : VertxCodeSamplesPage
}, {
  "path" : "real-time/vertx-event-bus",
  "component" : VertxEventBusPage
} ];
@NgModule({
	imports:[RouterModule.forRoot(routes)
],
	declarations:[],
	providers: [],
	exports:[RouterModule
],
	bootstrap:[],
	schemas:[]
})
export class AngularRoutingModule
{

}
